<section tuiContent>
	@if (error()) {
		<div tuiNotification appearance="negative">
			{{ 'form.error.image-cropper.load' | transloco }}
		</div>
	} @else if (context.data.imageFile) {
		@if (loading()) {
			<div class="image-cropper-dialog__loader">
				<tui-loader size="xl" />
			</div>
		}

		<image-cropper
			[imageFile]="context.data.imageFile"
			[maintainAspectRatio]="true"
			[aspectRatio]="aspectRatio()"
			format="png"
			[disabled]="loading()"
			(imageCropped)="onImageCropped($event)"
			(imageLoaded)="onImageLoaded()"
			(cropperReady)="onCropperReady()"
			(loadImageFailed)="onLoadImageFailed()"
		/>
	}
</section>

<footer tuiFooter>
	<button tuiButton appearance="outline" (click)="onDismiss()">
		{{ 'action.cancel' | transloco }}
	</button>
	<button
		tuiButton
		appearance="accent"
		(click)="onSave()"
		[disabled]="loading() || error()"
	>
		{{ 'action.save' | transloco }}
	</button>
</footer>
